import axios from "axios";

// const devToken = "73fa6fdc7b8b7efbc0e940ac301fc195d0bed1347beea6aa7d7e7907abcbc7956d2b56b906880a9e5784cbecb24f320d0eeb9522b3f795982500bcc58b07a5de79a5c778e45c2805e9056bd52044184544f6daeeb8e2427ab81ffc9b89c38e371c96f105d16e20931fbbc7697580957c38ba36bb5427c792531fbbf17e4451bc";
// const devBearToken = "Bearer " + devToken; 
// const DEV_BASE_URL = "https://dev-cms.paykoko.com"


// const qaToken = "5e0442aed4ab9a7b0ff8f80c0d7572d91bee8a7724af74f0dd6c08fcb30f747598523ddc698efb3008a356e3134ec294e5f3c3e4ac30d31e359bbab9b3658e427caa4d5fda38cb33b1b8bd8da35afef296afecc85bd9477a7f4faf1b5cf449981bcc6f69e771f0abc657beb79660a21bb48e3a3e4441b2641f8eda559b9fcc15";
// const qaBearToken = "Bearer " + qaToken; 
// const QA_BASE_URL = "https://qa-cms.paykoko.com";

const Token =
  "44587566452cdd6463c3482e4b57853ff3292495d04632bc500b74009b8e943fd1ab9f35dd7cd7ce285993bf792ebe4134159527b0bd54e2e805fcd8e3cdd63b8eaf8be5cdb9100a8bae554f9f7b3ec128bbf7eccaac6eec9ecd1c58d78552f2b8d633685e5538ea60b8104a11c515a01f56177dee1fe0d83fe57fa979955646";
const bearToken = "Bearer " + Token;
const BASE_URL = "https://cms.paykoko.com";


export default class Strapi {
  // get merchants by campain category
  getMerchantsByCategory(slug) {
    const param = slug.toLowerCase();
    const utcTime = new Date().toISOString();
    
    let auth = {
      headers: {
        Authorization: bearToken,
      },
    };

    const urlParams = new URLSearchParams({
      'populate': '*',
      'filters[discount_start_date][$lt]': utcTime,
      'filters[discount_end_date][$gt]': utcTime,
      'filters[campaign_merchant_categories][categoryName][$eq]': param,
      'sort[0]': "rank:asc"
    });
  
    return new Promise((res, rej) => {
      axios
        .get(
          `${BASE_URL}/api/merchant-webs?${urlParams}`,
          auth
        )
        .then((response) => {
          res(response.data);
        })
        .catch((err) => {
          rej("No data", err);
        });
    });
  }
  

  getOnsiteSettings() {
    let auth = {
      headers: {
        Authorization: bearToken,
      },
    };
    // let auth = bearToken;
    return new Promise((res, rej) => {
      axios
        .get(BASE_URL + "/api/onsite-settings/?populate=*", auth)
        .then((response) => {
          res(response.data);
        })
        .catch((err) => {
          rej("No data", err);
        });
    });
  }
  getMerchants(tabName, currentPage,) {
    let auth = {
      headers: {
        Authorization: bearToken,
      },
    };
    // let sortingKey = tabName === "searchRankOverall" ? "searchRankOverall" : "searchRank30Days" ? "searchRank30Days" : "discountValue" ;
    let sortMethod = tabName === "discountValue" ? "desc" : "asc";
    let pageSize = 6*currentPage;
    // let auth = bearToken;
    return new Promise((res, rej) => {
      axios
        // .get(BASE_URL + "/api/merchant-webs?sort=searchRankOverall:desc&pagination[page]=1&pagination[pageSize]=6", auth)
        .get(BASE_URL + `/api/merchant-webs?sort=${tabName}:${sortMethod}&pagination[page]=1&pagination[pageSize]=${pageSize}&populate=*&filters[${tabName}][$notNull]=true`, auth)
        .then((response) => {
          res(response.data);
        })
        .catch((err) => {
          rej("No data", err);
        });
    });
  }
  getAllHeroBanners() {
    let auth = {
      headers: {
        Authorization: bearToken,
      },
    };
    // let auth = bearToken;
    return new Promise((res, rej) => {
      axios
        .get(BASE_URL + "/api/hero-banners/?populate=*", auth)
        .then((response) => {
          res(response.data);
        })
        .catch((err) => {
          rej("No data", err);
        });
    });
  }

  getAllStripBanners() {
    let auth = {
      headers: {
        Authorization: bearToken,
      },
    };

    return new Promise((res, rej) => {
      axios
        .get(BASE_URL + "/api/strip-banners/?populate=*", auth)
        .then((response) => {
          res(response.data);
        })
        .catch((err) => {
          rej("No data", err);
        });
    });
  }

  getDealsStripBanners() {
    let auth = {
      headers: {
        Authorization: bearToken,
      },
    };

    return new Promise((res, rej) => {
      axios
        .get(BASE_URL + "/api/deals-strip-banners/?populate=*", auth)
        .then((response) => {
          res(response.data);
        })
        .catch((err) => {
          rej("No data", err);
        });
    });
  }

  getAllCategories() {
    let auth = {
      headers: {
        Authorization: bearToken,
      },
    };

    return new Promise((res, rej) => {
      axios
        .get(BASE_URL + "/api/categories/?populate=*", auth)
        .then((response) => {
          res(response.data);
        })
        .catch((err) => {
          rej("No data", err);
        });
    });
  }
  getMerchantDeals() {
    let auth = {
      headers: {
        Authorization: bearToken,
      },
    };

    return new Promise((res, rej) => {
      axios
        .get(
          BASE_URL +
          "/api/merchant-deals/?populate=%2A&filters[tags][tag_name][$eq]=alldeals",
          auth
        )
        .then((response) => {
          res(response.data);
        })
        .catch((err) => {
          rej("No data", err);
        });
    });
  }
  getMercListByCat(parameter, page, itemsPerPage) {
    let auth = {
      headers: {
        Authorization: bearToken,
      },
    };

    let category = parameter;

    return new Promise((res, rej) => {
      axios
        .get(
          BASE_URL +
          "/api/merchant-webs?pagination[page]=" + page + "&pagination[pageSize]=" + itemsPerPage + "&populate=%2A&sort[0]=rank:asc&sort[1]=updatedAt:desc&filters[tags][tag_name][$eq]=" +
          category,
          auth
        )
        .then((response) => {
          res(response.data);
        })
        .catch((err) => {
          rej("No data", err);
        });
    });
  }

  GetTheSelectedMercById(param) {
    let auth = {
      headers: {
        Authorization: bearToken,
      },
    };

    let MerchantId = param;

    return new Promise((res, rej) => {
      axios
        .get(
          BASE_URL + "/api/merchant-webs/" + MerchantId + "?populate=*",
          auth
        )
        .then((response) => {
          res(response.data);
        })
        .catch((err) => {
          rej("No data", err);
        });
    });
  }

  // Campaign Page Merchants - Mart
  getMartMerchants() {
    let auth = {
      headers: {
        Authorization: bearToken,
      },
    };

    const param = "mart";

    return new Promise((res, rej) => {
      axios
        .get(
          BASE_URL + "/api/merchant-webs?populate=%2A&filters[campaign_merchant_categories][CategoryName][$eq]=" +
          param,
          auth
        )
        .then((response) => {
          res(response.data);
        })
        .catch((err) => {
          rej("No data", err);
        });
    });
  }

  // Campaign Page Merchants - Top Deals

  getTopdealsMerchants() {
    // const Token =
    //   "f6935482ab5cd703a3a6fcff4fce6617c68dcfdc7a479f3ba5c7e811d5bd5158442068fa633a6a32b6796a33c2d5aac1c3c94862317ae2825d1e7ff1be3477da13bc96e397ca51bfdc900022de45fc1d96ff77885245f0720cd505baf5a17baf82a9209736e9e9d4913905cceee9b3f14cc88d26e17d5694f0cde6a1d055d87e";

    // const bearTokenTest = "Bearer " + Token;

    const param = "topdeals";

    let auth = {
      headers: {
        Authorization: bearToken,
      },
    };

    return new Promise((res, rej) => {
      axios
        .get(
          BASE_URL +
          "/api/merchant-webs?populate=%2A&filters[campaign_merchant_categories][CategoryName][$eq]=" +
          param,
          auth
        )
        .then((response) => {
          res(response.data);
        })
        .catch((err) => {
          rej("No data", err);
        });
    });
  }

  getElectronicsMerchants() {
    // const Token =
    //   "f6935482ab5cd703a3a6fcff4fce6617c68dcfdc7a479f3ba5c7e811d5bd5158442068fa633a6a32b6796a33c2d5aac1c3c94862317ae2825d1e7ff1be3477da13bc96e397ca51bfdc900022de45fc1d96ff77885245f0720cd505baf5a17baf82a9209736e9e9d4913905cceee9b3f14cc88d26e17d5694f0cde6a1d055d87e";

    // const bearTokenTest = "Bearer " + Token;

    const param = "electronics";

    let auth = {
      headers: {
        Authorization: bearToken,
      },
    };

    return new Promise((res, rej) => {
      axios
        .get(
          BASE_URL +
          "/api/merchant-webs?populate=%2A&filters[campaign_merchant_categories][CategoryName][$eq]=" +
          param,
          auth
        )
        .then((response) => {
          res(response.data);
        })
        .catch((err) => {
          rej("No data", err);
        });
    });
  }

  getFashionMerchants() {
    // const Token =
    //   "f6935482ab5cd703a3a6fcff4fce6617c68dcfdc7a479f3ba5c7e811d5bd5158442068fa633a6a32b6796a33c2d5aac1c3c94862317ae2825d1e7ff1be3477da13bc96e397ca51bfdc900022de45fc1d96ff77885245f0720cd505baf5a17baf82a9209736e9e9d4913905cceee9b3f14cc88d26e17d5694f0cde6a1d055d87e";

    // const bearTokenTest = "Bearer " + Token;

    const param = "fashion";

    let auth = {
      headers: {
        Authorization: bearToken,
      },
    };

    return new Promise((res, rej) => {
      axios
        .get(
          BASE_URL +
          "/api/merchant-webs?populate=%2A&filters[campaign_merchant_categories][CategoryName][$eq]=" +
          param,
          auth
        )
        .then((response) => {
          res(response.data);
        })
        .catch((err) => {
          rej("No data", err);
        });
    });
  }

  getLifeStyleMerchants() {
    // const Token =
    //   "f6935482ab5cd703a3a6fcff4fce6617c68dcfdc7a479f3ba5c7e811d5bd5158442068fa633a6a32b6796a33c2d5aac1c3c94862317ae2825d1e7ff1be3477da13bc96e397ca51bfdc900022de45fc1d96ff77885245f0720cd505baf5a17baf82a9209736e9e9d4913905cceee9b3f14cc88d26e17d5694f0cde6a1d055d87e";

    // const bearTokenTest = "Bearer " + Token;

    const param = "lifestyle";

    let auth = {
      headers: {
        Authorization: bearToken,
      },
    };

    return new Promise((res, rej) => {
      axios
        .get(
          BASE_URL +
          "/api/merchant-webs?populate=%2A&filters[campaign_merchant_categories][CategoryName][$eq]=" +
          param,
          auth
        )
        .then((response) => {
          res(response.data);
        })
        .catch((err) => {
          rej("No data", err);
        });
    });
  }

  getBeautyCosmeticsMerchants() {
    // const Token =
    //   "f6935482ab5cd703a3a6fcff4fce6617c68dcfdc7a479f3ba5c7e811d5bd5158442068fa633a6a32b6796a33c2d5aac1c3c94862317ae2825d1e7ff1be3477da13bc96e397ca51bfdc900022de45fc1d96ff77885245f0720cd505baf5a17baf82a9209736e9e9d4913905cceee9b3f14cc88d26e17d5694f0cde6a1d055d87e";

    // const bearTokenTest = "Bearer " + Token;

    const param = "healthandbeauty";

    let auth = {
      headers: {
        Authorization: bearToken,
      },
    };

    return new Promise((res, rej) => {
      axios
        .get(
          BASE_URL +
          "/api/merchant-webs?populate=%2A&filters[campaign_merchant_categories][CategoryName][$eq]=" +
          param,
          auth
        )
        .then((response) => {
          res(response.data);
        })
        .catch((err) => {
          rej("No data", err);
        });
    });
  }

  getFitnessMerchants() {
    // const Token =
    //   "f6935482ab5cd703a3a6fcff4fce6617c68dcfdc7a479f3ba5c7e811d5bd5158442068fa633a6a32b6796a33c2d5aac1c3c94862317ae2825d1e7ff1be3477da13bc96e397ca51bfdc900022de45fc1d96ff77885245f0720cd505baf5a17baf82a9209736e9e9d4913905cceee9b3f14cc88d26e17d5694f0cde6a1d055d87e";

    // const bearTokenTest = "Bearer " + Token;

    const param = "fitness";

    let auth = {
      headers: {
        Authorization: bearToken,
      },
    };

    return new Promise((res, rej) => {
      axios
        .get(
          BASE_URL +
          "/api/merchant-webs?populate=%2A&filters[campaign_merchant_categories][CategoryName][$eq]=" +
          param,
          auth
        )
        .then((response) => {
          res(response.data);
        })
        .catch((err) => {
          rej("No data", err);
        });
    });
  }


  getOtherMerchants() {
    // const Token =
    //   "f6935482ab5cd703a3a6fcff4fce6617c68dcfdc7a479f3ba5c7e811d5bd5158442068fa633a6a32b6796a33c2d5aac1c3c94862317ae2825d1e7ff1be3477da13bc96e397ca51bfdc900022de45fc1d96ff77885245f0720cd505baf5a17baf82a9209736e9e9d4913905cceee9b3f14cc88d26e17d5694f0cde6a1d055d87e";

    // const bearTokenTest = "Bearer " + Token;

    const param = "otherdeals";

    let auth = {
      headers: {
        Authorization: bearToken,
      },
    };

    return new Promise((res, rej) => {
      axios
        .get(
          BASE_URL +
          "/api/merchant-webs?populate=%2A&filters[campaign_merchant_categories][CategoryName][$eq]=" +
          param,
          auth
        )
        .then((response) => {
          res(response.data);
        })
        .catch((err) => {
          rej("No data", err);
        });
    });
  }

  getRestaurantMerchants() {
    // const Token =
    //   "f6935482ab5cd703a3a6fcff4fce6617c68dcfdc7a479f3ba5c7e811d5bd5158442068fa633a6a32b6796a33c2d5aac1c3c94862317ae2825d1e7ff1be3477da13bc96e397ca51bfdc900022de45fc1d96ff77885245f0720cd505baf5a17baf82a9209736e9e9d4913905cceee9b3f14cc88d26e17d5694f0cde6a1d055d87e";

    // const bearTokenTest = "Bearer " + Token;

    const param = "restaurants";

    let auth = {
      headers: {
        Authorization: bearToken,
      },
    };

    return new Promise((res, rej) => {
      axios
        .get(
          BASE_URL +
          "/api/merchant-webs?populate=%2A&filters[campaign_merchant_categories][CategoryName][$eq]=" +
          param,
          auth
        )
        .then((response) => {
          res(response.data);
        })
        .catch((err) => {
          rej("No data", err);
        });
    });
  }

  getTravelMerchants() {
    // const Token =
    //   "f6935482ab5cd703a3a6fcff4fce6617c68dcfdc7a479f3ba5c7e811d5bd5158442068fa633a6a32b6796a33c2d5aac1c3c94862317ae2825d1e7ff1be3477da13bc96e397ca51bfdc900022de45fc1d96ff77885245f0720cd505baf5a17baf82a9209736e9e9d4913905cceee9b3f14cc88d26e17d5694f0cde6a1d055d87e";

    // const bearTokenTest = "Bearer " + Token;

    const param = "travel";

    let auth = {
      headers: {
        Authorization: bearToken,
      },
    };

    return new Promise((res, rej) => {
      axios
        .get(
          BASE_URL +
          "/api/merchant-webs?populate=%2A&filters[campaign_merchant_categories][CategoryName][$eq]=" +
          param,
          auth
        )
        .then((response) => {
          res(response.data);
        })
        .catch((err) => {
          rej("No data", err);
        });
    });
  }

  getFootwearMerchants() {
    // const Token =
    //   "f6935482ab5cd703a3a6fcff4fce6617c68dcfdc7a479f3ba5c7e811d5bd5158442068fa633a6a32b6796a33c2d5aac1c3c94862317ae2825d1e7ff1be3477da13bc96e397ca51bfdc900022de45fc1d96ff77885245f0720cd505baf5a17baf82a9209736e9e9d4913905cceee9b3f14cc88d26e17d5694f0cde6a1d055d87e";

    // const bearTokenTest = "Bearer " + Token;

    const param = "footwear";

    let auth = {
      headers: {
        Authorization: bearToken,
      },
    };

    return new Promise((res, rej) => {
      axios
        .get(
          BASE_URL +
          "/api/merchant-webs?populate=%2A&filters[campaign_merchant_categories][CategoryName][$eq]=" +
          param,
          auth
        )
        .then((response) => {
          res(response.data);
        })
        .catch((err) => {
          rej("No data", err);
        });
    });
  }

  getCampaignPageHeroBanners() {
    // const Token =
    //   "f6935482ab5cd703a3a6fcff4fce6617c68dcfdc7a479f3ba5c7e811d5bd5158442068fa633a6a32b6796a33c2d5aac1c3c94862317ae2825d1e7ff1be3477da13bc96e397ca51bfdc900022de45fc1d96ff77885245f0720cd505baf5a17baf82a9209736e9e9d4913905cceee9b3f14cc88d26e17d5694f0cde6a1d055d87e";

    // const bearTokenTest = "Bearer " + Token;

    let auth = {
      headers: {
        Authorization: bearToken,
      },
    };

    return new Promise((res, rej) => {
      axios
        .get(BASE_URL + "/api/campaign-hero-banners/?populate=*", auth)
        .then((response) => {
          res(response.data);
        })
        .catch((err) => {
          rej("No data", err);
        });
    });
  }

  // Hot Products

  getAllProductList() {
    // const Token =
    //   "f6935482ab5cd703a3a6fcff4fce6617c68dcfdc7a479f3ba5c7e811d5bd5158442068fa633a6a32b6796a33c2d5aac1c3c94862317ae2825d1e7ff1be3477da13bc96e397ca51bfdc900022de45fc1d96ff77885245f0720cd505baf5a17baf82a9209736e9e9d4913905cceee9b3f14cc88d26e17d5694f0cde6a1d055d87e";

    // const bearTokenTest = "Bearer " + Token;

    let auth = {
      headers: {
        Authorization: bearToken,
      },
    };

    return new Promise((res, rej) => {
      axios
        .get(BASE_URL + "/api/hot-products?populate=*", auth)
        .then((response) => {
          res(response.data);
        })
        .catch((err) => {
          rej("No data", err);
        });
    });
  }

  // Home Page Categories
  getHomePageCategoriesList() {
    let auth = {
      headers: {
        Authorization: bearToken,
      },
    };

    return new Promise((res, rej) => {
      axios
        .get(BASE_URL + "/api/home-page-categories?populate=*", auth)
        .then((response) => {
          res(response.data);
        })
        .catch((err) => {
          rej("No data", err);
        });
    });
  }

  // Deals Page Categories
  getDealsPageCategoriesList() {
    let auth = {
      headers: {
        Authorization: bearToken,
      },
    };

    return new Promise((res, rej) => {
      axios
        .get(BASE_URL + "/api/deals-page-categories?populate=*", auth)
        .then((response) => {
          res(response.data);
          console.log(response.data);
        })
        .catch((err) => {
          rej("No data", err);
        });
    });
  }

  // Get featured Stores Merchants

  getFeaturedStoresMerchants() {
    let auth = {
      headers: {
        Authorization: bearToken,
      },
    };

    let category = "featured_stores";

    return new Promise((res, rej) => {
      axios
        .get(
          BASE_URL +
          "/api/merchant-webs?populate=%2A&sort[0]=rank:asc&sort[1]=updatedAt:desc&filters[tags][tag_name][$eq]=" +
          category,
          auth
        )
        .then((response) => {
          res(response.data);
        })
        .catch((err) => {
          rej("No data", err);
        });
    });
  }

  // Fetch Hot Deals Merchants
  getHotDealsMerchants() {
    let auth = {
      headers: {
        Authorization: bearToken,
      },
    };

    return new Promise((res, rej) => {
      axios
        .get(BASE_URL + "/api/hot-deals?populate=*", auth)
        .then((response) => {
          res(response.data);
        })
        .catch((err) => {
          rej("No data", err);
        });
    });
  }

  getInspirationalListThumbnails() {
    let auth = {
      headers: {
        Authorization: bearToken,
      },
    };

    return new Promise((res, rej) => {
      axios
        .get(BASE_URL + "/api/inspirational-lists?populate=*", auth)
        .then((response) => {
          res(response.data);
        })
        .catch((err) => {
          rej("No data", err);
        });
    });
  }
  getInspirationalAllProducts() {
    let auth = {
      headers: {
        Authorization: bearToken,
      },
    };

    return new Promise((res, rej) => {
      axios
        .get(BASE_URL + "/api/inspirational-list-products?populate=*", auth)
        .then((response) => {
          res(response.data);
        })
        .catch((err) => {
          rej("No data", err);
        });
    });
  }

  getInspirationalProductsBySlug(parameter) {
    let auth = {
      headers: {
        Authorization: bearToken,
      },
    };

    let slug = parameter;
    return new Promise((res, rej) => {
      axios
        .get(
          BASE_URL +
          "/api/inspirational-list-products?populate=%2A&filters[inspirational_List][slug][$eq]=" +
          slug,
          auth
        )
        .then((response) => {
          res(response.data);
        })
        .catch((err) => {
          rej("No data", err);
        });
    });
  }
  // Fetch All Top Electronics Merchants
  GetElectronicsMerchantsList() {
    let auth = {
      headers: {
        Authorization: bearToken,
      },
    };

    return new Promise((res, rej) => {
      axios
        .get(BASE_URL + "/api/top-electronics?populate=*", auth)
        .then((response) => {
          res(response.data);
        })
        .catch((err) => {
          rej("No data", err);
        });
    });
  }

  // Fetch All Top Fashion Merchants
  GetFashionMerchantsList() {
    let auth = {
      headers: {
        Authorization: bearToken,
      },
    };

    return new Promise((res, rej) => {
      axios
        .get(BASE_URL + "/api/top-fashions?populate=*", auth)
        .then((response) => {
          res(response.data);
        })
        .catch((err) => {
          rej("No data", err);
        });
    });
  }

  // Fetch All Top Lifestyle Merchants

  GetLifeStyleMerchantsList() {
    let auth = {
      headers: {
        Authorization: bearToken,
      },
    };

    return new Promise((res, rej) => {
      axios
        .get(BASE_URL + "/api/top-home-and-life-styles?populate=*", auth)
        .then((response) => {
          res(response.data);
        })
        .catch((err) => {
          rej("No data", err);
        });
    });
  }

  GetBeaytyMerchantsList() {
    let auth = {
      headers: {
        Authorization: bearToken,
      },
    };

    return new Promise((res, rej) => {
      axios
        .get(BASE_URL + "/api/top-health-and-beauties?populate=*", auth)
        .then((response) => {
          res(response.data);
        })
        .catch((err) => {
          rej("No data", err);
        });
    });
  }

  GetRestaurantMerchantsList() {
    let auth = {
      headers: {
        Authorization: bearToken,
      },
    };

    return new Promise((res, rej) => {
      axios
        .get(BASE_URL + "/api/top-restaurants-and-cafes?populate=*", auth)
        .then((response) => {
          res(response.data);
        })
        .catch((err) => {
          rej("No data", err);
        });
    });
  }

  // Fetch All pay day sale Merchants
  GetPayDayDeals() {
    let auth = {
      headers: {
        Authorization: bearToken,
      },
    };

    return new Promise((res, rej) => {
      axios
        .get(BASE_URL + "/api/top-electronics?populate=*", auth)
        .then((response) => {
          res(response.data);
        })
        .catch((err) => {
          rej("No data", err);
        });
    });
  }

  getTheCategoryPageBannerByCatName(parameter) {
    let auth = {
      headers: {
        Authorization: bearToken,
      },
    };

    let slug = parameter;
    return new Promise((res, rej) => {
      axios
        .get(
          BASE_URL +
          "/api/category-page-banners?populate=%2A&filters[tags][tag_name][$eq]=" +
          slug,
          auth
        )
        .then((response) => {
          res(response.data);
        })
        .catch((err) => {
          rej("No data", err);
        });
    });
  }
  getSecondaryStripBanners() {
    let auth = {
      headers: {
        Authorization: bearToken,
      },
    };

    return new Promise((res, rej) => {
      axios
        .get(BASE_URL + "/api/secondary-strip-banners?populate=*", auth)
        .then((response) => {
          res(response.data);
        })
        .catch((err) => {
          rej("No data", err);
        });
    });
  }

  getSecondaryHeroBanners() {
    let auth = {
      headers: {
        Authorization: bearToken,
      },
    };

    return new Promise((res, rej) => {
      axios
        .get(BASE_URL + "/api/secondary-hero-banners?populate=*", auth)
        .then((response) => {
          res(response.data);
        })
        .catch((err) => {
          rej("No data", err);
        });
    });
  }

  getFirstClusterBanner() {
    let auth = {
      headers: {
        Authorization: bearToken,
      },
    };

    return new Promise((res, rej) => {
      axios
        .get(BASE_URL + "/api/first-cluster-banners?populate=*", auth)
        .then((response) => {
          res(response.data);
        })
        .catch((err) => {
          rej("No data", err);
        });
    });
  }

  getSecondClusterBanner() {
    let auth = {
      headers: {
        Authorization: bearToken,
      },
    };

    return new Promise((res, rej) => {
      axios
        .get(BASE_URL + "/api/second-cluster-banners?populate=*", auth)
        .then((response) => {
          res(response.data);
        })
        .catch((err) => {
          rej("No data", err);
        });
    });
  }

  GetHomePageModules() {
    let auth = {
      headers: {
        Authorization: bearToken,
      },
    };
    return new Promise((res, rej) => {
      axios
        .get(BASE_URL + "/api/home-page-modules?populate=*", auth)
        .then((response) => {
          res(response.data);
        })
        .catch((err) => {
          rej("No data", err);
        });
    });

  }
}